(ns frontend.view.modals.delete-confirmation.event
  (:require [frontend.controller.websocket.event :as ws]
            [frontend.view.modals.delete-confirmation.model :as model]
            [re-frame.core :as rf]))

(rf/reg-event-fx
 ::cleanup
 (fn [{db :db} _]
   {:db (model/cleanup db)}))

(rf/reg-event-fx
 ::init
 (fn [{db :db} [_ entity-id]]
   {:db       (-> db
                  (model/cleanup)
                  (model/start-loading entity-id))
    ::ws/send {:id         :entity/check-disable-conflicts
               :body       {:db/id entity-id}
               :on-success [::loading-ok]
               :on-error   [::loading-failed]}}))

(rf/reg-event-fx
 ::loading-ok
 (fn [{db :db} [_ resp]]
   (js/console.log "Loading OK : " resp)
   {:db (model/set-conflicts db (:body resp))}))

(rf/reg-event-fx
 ::loading-failed
 (fn [{db :db} [_ err]]
   {:db (model/set-error db err)}))

(rf/reg-event-fx
 ::set-confirmed?
 (fn [{db :db} [_ confirmed?]]
   {:db (model/set-confirmed db confirmed?)}))

(rf/reg-event-fx
 ::disable-ok
 (fn [{db :db} [_ close!]]
   (close!)))

(rf/reg-event-fx
 ::disable-failed
 (fn [{db :db} [_ err]]
   {:db (model/set-error db err)}))

(rf/reg-event-fx
 ::disable!
 (fn [{db :db} [_ close!]]
   (let [entity-id (get-in db model/entity-id-full-path)]
     {:db       (model/start-processing? db)
      ::ws/send {:id         :entity/disable!
                 :body       {:entity-id entity-id}
                 :on-success [::disable-ok close!]
                 :on-error   [::disable-failed]}})))
